/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, Switch, Redirect } from "react-router-dom";
import { Flags } from "react-feature-flags";
import classNames from "classnames";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import Registration from "./Registration";
import OnBoarding from "./OnBoarding";
import ForgotPassword from "./ForgotPassword";
import { FormattedMessage } from "react-intl";
import backgroundImage from "../../../assets/images/bg.png";
import PerSiteFormatedMessage from "../../Globals/components/PerSiteFormatedMessage";
import { features, useFlags } from "../../../../config/featureFlags";
import logo from "../../../../_metronic/_assets/plugins/keenthemes-icons/svg/open-saiema-logo.svg";

import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import {Footer} from "../../../../_metronic/layout/components/footer/Footer";

export function AuthPage({ children }) {
  const { DISPLAY_CODE_CONTENT, DISPLAY_LIKUMI_CONTENT } = useFlags();

  const backgroungStyles = DISPLAY_CODE_CONTENT
    ? { position: "relative", backgroundColor: "black" }
    : {
        backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-5.jpg")})`,
      };

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat"
            style={backgroungStyles}
          >
            <Flags
              authorizedFlags={[features.DISPLAY_CODE_CONTENT]}
              renderOn={() => (
                <img
                  src={backgroundImage}
                  alt="Logo"
                  // TODO: move styles to class
                  style={{
                    opacity: 0.6,
                    zIndex: 1,
                    position: "absolute",
                    bottom: 0,
                    top: 0,
                    left: 0,
                    right: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              )}
            />
            {/*begin: Aside Container*/}
            <div
              className={classNames(
                "d-flex flex-row-fluid flex-column justify-content-between zindex-2",
                { "primary-bg-green": DISPLAY_LIKUMI_CONTENT }
              )}
            >
              {/* start:: Aside header */}
              <Flags
                authorizedFlags={[features.DISPLAY_LIKUMI_CONTENT]}
                renderOn={() => (
                  <Link to="/" className="flex-column-auto p-5 primary-bg-blue">
                    <img alt="Logo" className="max-h-200px" src={logo} style={{width:"100%"}} />
                  </Link>
                )}
              />
              {/* end:: Aside header */}
              {/* start:: Aside content */}
              <div className="flex-column-fluid d-flex flex-column justify-content-center p-8">
                <Flags
                  authorizedFlags={[features.DISPLAY_CODE_CONTENT]}
                  renderOn={() => (
                    <Link
                      to="/"
                      className="flex-column-auto mt-5 pb-lg-0 pb-10"
                    >
                      <img
                        alt="Logo"
                        className="max-h-50px"
                        src={toAbsoluteUrl("/media/logos/logo-letter-1.png")}
                        style={{ justifySelf: "flex-start" }}
                      />
                    </Link>
                  )}
                />
                <div className="flex-column-fluid d-flex flex-column justify-content-center">
                  <h1 className="text-white mb-10">
                    <PerSiteFormatedMessage id="AUTH.LOGIN.LEFT_SIDE.TITLE" />
                  </h1>
                  <Flags
                    authorizedFlags={[features.DISPLAY_LIKUMI_CONTENT]}
                    renderOn={() => (
                      <>
                        <h2 className="font-size-h4 text-white mb-10">
                          <PerSiteFormatedMessage id="AUTH.LOGIN.LEFT_SIDE.DESCRIPTION" />
                        </h2>
                        <p className="text-white">
                          <i className="fa fa-sm fa-check text-white" />{" "}
                          <PerSiteFormatedMessage id="AUTH.LOGIN.LEFT_SIDE.OPTION_1" />
                        </p>
                        <p className="text-white">
                          <i className="fa fa-sm fa-check text-white" />{" "}
                          <PerSiteFormatedMessage id="AUTH.LOGIN.LEFT_SIDE.OPTION_2" />
                        </p>
                        <p className="text-white">
                          <i className="fa fa-sm fa-check text-white" />{" "}
                          <PerSiteFormatedMessage id="AUTH.LOGIN.LEFT_SIDE.OPTION_3" />
                        </p>
                      </>
                    )}
                  />
                </div>
              </div>
              {/* end:: Aside content */}
              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10 p-10 p-lg-10">
                <div className="opacity-70 font-weight-bold	text-white">
                  &copy; {new Date().getFullYear()} ManaBalss.lv
                </div>
                <div className="d-flex">
                  <Link to="/privacy" className="text-white" target="_blank">
                    <PerSiteFormatedMessage id="AUTH.LOGIN.LEFT_SIDE.LINK_1" />
                  </Link>
                  <Link
                    to="/terms"
                    className="text-white ml-10"
                    target="_blank"
                  >
                    <FormattedMessage id="AUTH.LOGIN.LEFT_SIDE.LINK_2" />
                  </Link>
                  <a
                    href={
                      DISPLAY_LIKUMI_CONTENT
                        ? "https://myvoice.group/kontakti/"
                        : "/contacts"
                    }
                    className="text-white ml-10"
                  >
                    <FormattedMessage id="AUTH.LOGIN.LEFT_SIDE.LINK_3" />
                  </a>
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            {/*begin::Content header*/}
            <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
              {/*
              <span className="font-weight-bold text-dark-50">
                Don't have an account yet?
              </span>
              <Link
                to="/auth/registration"
                className="font-weight-bold ml-2"
                id="kt_login_signup"
              >
                Sign Up!
              </Link>
              */}
            </div>
            {/*end::Content header*/}

            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              {children}
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; {new Date().getFullYear()}
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <Link to="/privacy" className="text-dark-75 text-hover-primary">
                  <PerSiteFormatedMessage id="AUTH.LOGIN.LEFT_SIDE.LINK_1" />
                </Link>
                <Link
                  to="/terms"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  <FormattedMessage id="AUTH.LOGIN.LEFT_SIDE.LINK_2" />
                </Link>
                <a
                  href={
                    DISPLAY_LIKUMI_CONTENT
                      ? "https://myvoice.group/kontakti/"
                      : "/contacts"
                  }
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  <FormattedMessage id="AUTH.LOGIN.LEFT_SIDE.LINK_3" />
                </a>
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
        <Footer/>
      </div>
    </>
  );
}
